<script lang="ts">
    import { onMount } from 'svelte';
    import PageHeader from '../components/PageHeader.svelte';
    import { launchLoader, stopLoader } from '../scripts/utils';
    import { redirectTo } from '../scripts/router1';
    import { idPageHome, idPageLogin } from '../scripts/router2';
    import { addUser } from '../scripts/apiUsers';
    import { storeEnterprises, storeEnterprisesError } from '../scripts/enterprise';
    import { addNotificationError }  from "../scripts/toaster";
    import { storeLanguage, lang_fr } from "../scripts/store";
    import { get } from 'svelte/store';
    import { getEnterprises } from '../scripts/apiEnterprises';

    let email: string = "";
    let password: string = "";
    let password_bis: string = "";
    let first_name: string = "";
    let last_name: string = "";
    let enterprise: number = -1;
    let enterprise_other: string = "";
    let job: string = "";
    let eyePasswordClose: boolean = true;
    let eyePasswordBisClose: boolean = true;

    onMount(async () => {
        getEnterprisesIfEmpty();
        window.scrollTo(0,0);
	});

     /**
     * getEnterprisesIfEmpty
     */
     function getEnterprisesIfEmpty() {
        if ($storeEnterprises.length <= 0) {
            launchLoader();
            const returnValue = getEnterprises();
            returnValue.then((data) => {
                stopLoader();
                if (!data) {
                    addNotificationError($storeEnterprisesError);
                };
            });
        }
    }

    /**
     * registration
     */
    function registration() {
        if (checkData()) {
            launchLoader();
            const isCreate = addUser(email, password, first_name, last_name, enterprise, enterprise_other, job);
            isCreate.then((data) => {
                if (data == "200"){
                    redirectTo(idPageHome);
                } else if (data == "409") {
                    redirectTo(idPageLogin);
                }
                stopLoader();
            })
        }
    }

    /**
     * checkData
     */
    function checkData() {
        let isChecked: boolean = true;
        if (email == undefined || email == "") {
            if (get(storeLanguage) == get(lang_fr)) {
                addNotificationError("Merci de renseigner l'email");
            } else {
                addNotificationError("Please fill in the email");
            }
            isChecked = false;
        } else if (!validateEmail(email)) {
            if (get(storeLanguage) == get(lang_fr)) {
                addNotificationError("Email invalide");
            } else {
                addNotificationError("Invalid email");
            }
            isChecked = false;
        }

        if (password == undefined || password == "") {
            if (get(storeLanguage) == get(lang_fr)) {
                addNotificationError("Merci de renseigner le mot de passe");
            } else {
                addNotificationError("Please fill in the password");
            }
            isChecked = false;
        } else if (password != password_bis) {
            if (get(storeLanguage) == get(lang_fr)) {
                addNotificationError("Merci de renseigner le même mot de passe");
            } else {
                addNotificationError("Please fill in same password");
            }
            isChecked = false;

        }
        if (first_name == undefined || first_name == "") {
            if (get(storeLanguage) == get(lang_fr)) {
                addNotificationError("Merci de renseigner le prénom");
            } else {
                addNotificationError("Please fill in the first name");
            }
            isChecked = false;
        }
        if (last_name == undefined || last_name == "") {
            if (get(storeLanguage) == get(lang_fr)) {
                addNotificationError("Merci de renseigner le nom");
            } else {
                addNotificationError("Please fill in the last name");
            }
            isChecked = false;
        }
        if (enterprise == undefined || enterprise < 0) {
            if (get(storeLanguage) == get(lang_fr)) {
                addNotificationError("Merci de sélectionner une entreprise");
            } else {
                addNotificationError("Please select a company");
            }
            isChecked = false;
        } else if (enterprise == 99 && enterprise_other == "") {
            if (get(storeLanguage) == get(lang_fr)) {
                addNotificationError("Merci de renseigner le nom de l'entreprise");
            } else {
                addNotificationError("Please fille enterprise name");
            }
            isChecked = false;
        }
        if (job == undefined || job == "") {
            if (get(storeLanguage) == get(lang_fr)) {
                addNotificationError("Merci de renseigner la fonction");
            } else {
                addNotificationError("Please fill in the function");
            }
            isChecked = false;
        }
        return isChecked;
    }

    /**
     * validateEmail
     * @param email
     */
    function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    function toggleEyePassword() {
        eyePasswordClose = !eyePasswordClose;
        let eltPassword = document.getElementById("idPassword");
        if (eyePasswordClose) {
            eltPassword.setAttribute("type", "password");
        } else {
            eltPassword.setAttribute("type", "text");
        }
    }

    function toggleEyePasswordBis() {
        eyePasswordBisClose = !eyePasswordBisClose;
        let eltPassword = document.getElementById("idPasswordBis");
        if (eyePasswordBisClose) {
            eltPassword.setAttribute("type", "password");
        } else {
            eltPassword.setAttribute("type", "text");
        }
    }

</script>
    
<style lang="scss">

    .registration {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        margin: 0 0 40px 0;
        &__bloc {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: flex-start;
            margin: 40px 0 0 0;
        }
        &__intro {
            width: 95%;
            margin: 30px 0 0 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        &__input {
            margin: 0 0 40px 0;
            border: 1px solid $color_orange;
            background-color: $color_primary;
            color: $color_white;
            border-radius: 5px;
            &::placeholder {
                color: $color_white;
                font-style: italic;
                opacity: 0.5;
            }
            &::file-selector-button {
                background: linear-gradient(to right, $color_primary, $color_orange);
                border-radius: 2px;
                color: $color_white;
                cursor: pointer;
                border: 1px solid $color_white;
            }
            &__hidden {
                display: none;
            }
            &__password {
                margin: 0 0 0 0;
            }
        }
        &__select {
            margin: 0 0 40px 0;
            background-color: $color_primary;
            border: 1px solid $color_orange;
            color: $color_white;
            border-radius: 5px;
            &::placeholder {
                color: $color_white;
                font-style: italic;
            }
        }
        &__eye {
            width: 30px;
            height: 30px;
            cursor: pointer;
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
            margin: 0 0 40px 10px;
            &__close {
                background-image: url("../assets/images/eye_open.png");
            }
            &__open {
                background-image: url("../assets/images/eye_close.png");
            }
        }
        &__password {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
        }
    }



    @include large {
        .registration {
            &__bloc {
                width: 40%;
                align-items: stretch;
            }
            &__intro {
                width: 60%;
            }
            &__password {
                flex-direction: row;
            }
            &__input {
                &__password {
                    margin: 0 0 40px 0;
                }
            }
        }
    }

</style>

<div class="registration">
    {#if ($storeLanguage == $lang_fr)}
    <PageHeader props="S'inscrire"/>
    {:else}
    <PageHeader props="Registration"/>
    {/if}
    {#if ($storeLanguage == $lang_fr)}
    <div class="registration__intro">
        En tant que contributeur, vous pourrez écrire un article dédié aux APIs sur notre site, n’hésitez pas !<br>Et si vous faites partie de notre collectif, vous pourrez accéder aux fichiers de toutes nos sessions plénières.
    </div>
    <form class="bloc registration__bloc">
        <label for="email">Adresse mail</label>
        <input class="registration__input font" type="email" name="email" placeholder="adresse mail" bind:value={email}>
        <label for="password">Mot de passe</label>
        <div class="registration__password">
            <input id="idPassword" class="registration__input registration__input__password font" type="password" name="password" placeholder="mot de passe" bind:value={password}>
            <div class="registration__eye" class:registration__eye__close={eyePasswordClose} class:registration__eye__open={!eyePasswordClose} on:click={() => toggleEyePassword()} on:keydown={() => toggleEyePassword()}></div>
        </div>
        <label for="password_bis">Confirmation du mot de passe</label>
        <div class="registration__password">
            <input id="idPasswordBis" class="registration__input registration__input__password font" type="password" name="password_bis" placeholder="mot de passe" bind:value={password_bis}>
            <div class="registration__eye" class:registration__eye__close={eyePasswordBisClose} class:registration__eye__open={!eyePasswordBisClose} on:click={() => toggleEyePasswordBis()} on:keydown={() => toggleEyePasswordBis()}></div>
        </div>
        <label for="first_name">Prénom</label>
        <input class="registration__input font" type="text" name="first_name" placeholder="prénom" bind:value={first_name}>
        <label for="last_name">Nom</label>
        <input class="registration__input font" type="text" name="last_name" placeholder="nom" bind:value={last_name}>
        <label for="enterprise">Entreprise</label>
        <select class="registration__select" name="enterprise" placeholder="sélectionner une entreprise" bind:value={enterprise}>
            <option value=99>-- autre, précisez --</option>
            {#each $storeEnterprises as oneEnterprise}
            <option value={oneEnterprise.id}>{oneEnterprise.name}</option>                
            {/each}
        </select>
        <label for="enterprise_other" class:registration__input__hidden={enterprise!=99}>Nom de l'entreprise</label>
        <input class="registration__input font" class:registration__input__hidden={enterprise!=99} type="text" name="enterprise_other" placeholder="nom entreprise" bind:value={enterprise_other}>
        <label for="job">Fonction dans l'entreprise</label>
        <input class="registration__input font" type="text" name="job" placeholder="fonction dans l'entreprise" bind:value={job}>
    </form>
    <input class="button" type="submit" on:click={registration} value="Je souhaite être membre">
    {:else}
    <div class="registration__intro">
        As a contributor, you can write an article dedicated to APIs on our site, don't hesitate!<br>And if you are part of our collective, you will be able to access the files of all our plenary sessions.
    </div>
    <form class="bloc registration__bloc">
        <label for="email">Email adress</label>
        <input class="registration__input font" type="email" name="email" placeholder="email adress" bind:value={email}>
        <label for="password">Password</label>
        <input class="registration__input font" type="password" name="password" placeholder="password" bind:value={password}>
        <label for="password_bis">Password confirmation</label>
        <input class="registration__input font" type="password" name="password_bis" placeholder="password" bind:value={password_bis}>
        <label for="first_name">First name</label>
        <input class="registration__input font" type="text" name="first_name" placeholder="first name" bind:value={first_name}>
        <label for="last_name">Last name</label>
        <input class="registration__input font" type="text" name="last_name" placeholder="last name" bind:value={last_name}>
        <label for="enterprise">Company</label>
        <select class="registration__select" name="enterprise" placeholder="select a company" bind:value={enterprise}>
            <option value=99>-- other, give details --</option>
            {#each $storeEnterprises as oneEnterprise}
            <option value={oneEnterprise.id}>{oneEnterprise.name}</option>                
            {/each}
        </select>
        <label for="enterprise_other" class:registration__input__hidden={enterprise!=99}>Enterprise name</label>
        <input class="registration__input font" class:registration__input__hidden={enterprise!=99} type="text" name="enterprise_other" placeholder="enterprise name" bind:value={enterprise_other}>
        <label for="job">Position in the company</label>
        <input class="registration__input font" type="text" name="job" placeholder="position in the company" bind:value={job}>
    </form>
    <input class="button" type="submit" on:click={registration} value="I want to be a member">
    {/if}
</div>

